const ESCAPED_MATH_FRAGMENT =
  /\\\$\s*((?:\^|_|)\{[-+A-Za-z0-9.,\s]+\})\\\$/g;

const LOOSE_CHEMISTRY_SUBSCRIPT =
  /([A-Za-z\)])\$\{([0-9]+(?:\.[0-9]+)?)\}\$/g;

export function normalizeMarkdownMath(content: string): string {
  return content
    .replace(ESCAPED_MATH_FRAGMENT, '$$$1$')
    .replace(/\$\s+(_\{[-+A-Za-z0-9.,\s]+\})\$/g, '$$$1$')
    .replace(LOOSE_CHEMISTRY_SUBSCRIPT, '$1$_{$2}$');
}
